import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, Link } from 'react-router-dom';
import { triggerAlert } from '../../utils/commonFunctions';
import { emailValidation, passwordValidations, trimValidation } from '../../utils/Constants';
import { updateUserPassword } from '../../utils/APIClient';
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // FontAwesome icons

export default function UpdatePassword() {
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const email = params.get('email');
        const token = params.get('token');
        const OTP = params.get('OTP');

        if (!email) {
            triggerAlert('info', '', 'Please check your email and try again to verify');
        }
    }, []);

    const onSubmit = async (data) => {
        const pathSegments = window.location.pathname.split('/').filter(Boolean); // remove empty parts
const uidb64 = pathSegments[pathSegments.length - 2];
const token = pathSegments[pathSegments.length - 1];

console.log("UIDB64:", uidb64);
console.log("Token:", token);

        try {
            const res = await updateUserPassword({
                password: data.password,
                uidb64: uidb64,
                token: token
            });

            if (res.status === 200) {
                triggerAlert('success', '', 'Password updated successfully');
                navigate('/login');
            }
        } catch (err) {
            console.error(err);
            triggerAlert('error', '', err?.response?.data?.error || 'Something went wrong');
        }
    };
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    return (
        <div className="auth-fluid">
            <div className="auth-fluid-form-box">
                <div className="card-body d-flex flex-column h1-100" style={{ height: '70%' }}>
                    <div className="auth-brand text-center text-lg-start">
                        <Link to="/" className="logo-dark">
                            <span><img src="/assets/images/logo.png" alt="dark logo" height={70} /></span>
                        </Link>
                    </div>
                    <div className="my-auto">
                        <h3 className="mt-0">Change Password</h3>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="mb-3 position-relative">
                                <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    className="form-control pe-5"
                                    placeholder="Enter your new password"
                                    autoComplete="new-password"
                                    {...register("password", {
                                        required: "Password is required",
                                        pattern: passwordValidations,
                                        ...trimValidation("It cannot be just spaces")
                                    })}
                                />
                                {errors.password && (
                                    <small className="text-danger d-block mb-2">
                                        {errors.password.message}
                                    </small>
                                )}
                                <span
                                    onClick={togglePasswordVisibility}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        top: "50%",
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#6c757d",
                                    }}
                                >
                                    {showPassword ? <FaEyeSlash /> : <FaEye />}
                                </span>
                            </div>

                            <div className="d-grid mb-0 text-center">
                                <button className="btn btn-success" type="submit">
                                    Update
                                </button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
            <div className="auth-fluid-right text-center">
                <div className="auth-user-testimonial">
                    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Seamless Voice Integration with Callingo</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> Using Callingo, I effortlessly built a Shopify app to recover abandoned checkouts, avoiding the usual hassle of integrating multiple APIs and dealing with latency or unnatural voice interruptions.</p>
                                <p>- Charlie Stigler (Founder, SpeakSage)</p>
                            </div>
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Relevance AI</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> Built an AI sales that do Cold Call & WhatsApp follow-up - powered by Callingo</p>
                                <p>- Kwindla Kramer</p>
                            </div>
                            <div className="carousel-item active">
                                <h2 className="mb-2 text-info">Feature Availability!</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> This is a great product, helped us a lot and very quick to work with and implement.</p>
                                <p>- TryDaily</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
